// extracted by mini-css-extract-plugin
export var container = "_i1-0";
export var segment = "_i1-2";
export var segmentActive = "_i1-3";
export var track = "_i1-1";